"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasUsableSiteCoordinates = void 0;
/**
 * Address.latitude / longitude default to 0 when unset (see address.entity.ts).
 * 0,0 is Null Island and is treated as "coordinates never set" for site weather.
 */
function hasUsableSiteCoordinates(latitude, longitude) {
    if (latitude === undefined ||
        longitude === undefined ||
        latitude === null ||
        longitude === null) {
        return false;
    }
    const lat = Number(latitude);
    const lon = Number(longitude);
    if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
        return false;
    }
    // Reject the Address column default (unset coordinates).
    if (lat === 0 && lon === 0) {
        return false;
    }
    return true;
}
exports.hasUsableSiteCoordinates = hasUsableSiteCoordinates;
